module.exports = __webpack_public_path__ + "static/Chofly-Elite-eb2d3781febd100c22a4ec78bd407e2a.png";